import { render, staticRenderFns } from "./AuthLoginSso.vue?vue&type=template&id=31aaa7b8&scoped=true"
import script from "./AuthLoginSso.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthLoginSso.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AuthLoginSso.vue?vue&type=style&index=0&id=31aaa7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aaa7b8",
  null
  
)

export default component.exports